import * as contentful from 'contentful'
import dotenv from 'dotenv'

dotenv.config()

console.log(process.env.SPACE_ID)

export const client = contentful.createClient({
  space: 'm2n3283ys9f6',
  accessToken: 'KNC8garK9nxzIN-fCJjPt5KPoZKZKD3CVDeLB4WCLhg',
})
